import type { NodePropertySchema } from '../../../types/node-properties';

const schema: NodePropertySchema = {
  nodeType: 'stop-execution',
  version: '1.0.0',
  properties: [
    {
      key: 'message',
      label: 'Message',
      type: 'string',
      default: 'Workflow execution stopped',
      required: false,
      description: 'A message explaining why the workflow was stopped',
      placeholder: 'e.g., Validation failed - missing required data'
    },
    {
      key: 'reason',
      label: 'Reason',
      type: 'options',
      default: 'user_requested',
      required: false,
      description: 'The reason category for stopping execution',
      options: [
        {
          name: 'User Requested',
          value: 'user_requested'
        },
        {
          name: 'Validation Failed',
          value: 'validation_failed'
        },
        {
          name: 'Condition Not Met',
          value: 'condition_not_met'
        },
        {
          name: 'Error Occurred',
          value: 'error_occurred'
        },
        {
          name: 'Data Missing',
          value: 'data_missing'
        },
        {
          name: 'Other',
          value: 'other'
        }
      ]
    }
  ]
};

export default schema;
